import { ContactUsBlockProps } from '~/components/ContactUsBlock/models';
import { ctaBlockMapper } from '~/mappers/ctaBlock';
import { linkBaseMapper } from '~/mappers/link';
import { pageBlockMapper } from '~/mappers/pageBlock';

import { fluidGridMapper } from '../fluidGrid';
import { ContactUsBlock } from './models';

export const contactUsBlockMapper = ({
  componentId,
  pageBlock,
  fluidGridUI,
  links,
  showMoreButton,
  ...rest
}: ContactUsBlock): ContactUsBlockProps => ({
  ...rest,
  // TODO - HKX-1311 - replace next line with: id: componentId,
  ...(componentId && { id: componentId }),
  pageBlock: pageBlockMapper(pageBlock),
  fluidGrid: fluidGridMapper(fluidGridUI[0]),
  links: links.map(({ link, title, ariaLabel, header }) => ({
    ...linkBaseMapper({ link, title, ariaLabel }),
    header,
  })),
  ...(showMoreButton?.length && {
    showMore: ctaBlockMapper(showMoreButton.map((link) => ({ link }))),
  }),
});
